import { on } from 'delegated-events'
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'

const state = {
  calendar: null,
}

const fn = {
  init: () => {
    const calendarEl = document.getElementById('events-calendar')

    if (calendarEl) {
      fn.setupCalendar(calendarEl)
    }

    on('click', '.events-view-controls button', fn.handleView)
  },

  handleView: (e) => {
    const button = e.target.closest('button')

    document.querySelectorAll('.events-view-controls .is-active').forEach((x) => x.classList.remove('is-active'))

    button.classList.add('is-active')

    const listView = document.querySelector('.events-view-list')
    const calendarView = document.querySelector('.events-view-calendar')

    if (button.dataset.view === 'list') {
      listView.classList.remove('hidden')
      calendarView.classList.add('hidden')
    } else {
      listView.classList.add('hidden')
      calendarView.classList.remove('hidden')

      if (state.calendar) {
        state.calendar.render()
      }
    }
  },

  setupCalendar: (el) => {
    const endpoint = el.dataset.endpoint

    const calendar = new Calendar(el, {
      plugins: [dayGridPlugin],
      initialView: 'dayGridMonth',
      headerToolbar: {
        left: '',
        center: 'prev,title,next',
        right: '',
      },
      events: (info, success) => {
        const query = { start: info.startStr, end: info.endStr }
        const urlParams = new URLSearchParams(window.location.search)
        const searchCategory = urlParams.get('category')
        const searchTerm = urlParams.get('search')

        if (searchCategory) {
          query.category = searchCategory
        }

        if (searchTerm) {
          query.search = searchTerm
        }

        ajax
          .url(endpoint)
          .query(query)
          .get()
          .json((resp) => {
            success(resp)
          })
      },
      eventDidMount: (info) => {
        info.el.setAttribute('data-modal', 'content')
      },
    })

    calendar.render()

    state.calendar = calendar
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-eventspage'),
  run: fn.init,
}
